export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "45d1064d-8d9d-40e6-bd10-35f8a310bf9a";
export const MODAL_CLOSE_SEC = 2.5;
